import {
  FETCH_AUDIT_TRAIL_FAILURE,
  FETCH_AUDIT_TRAIL_REQUEST,
  FETCH_AUDIT_TRAIL_SUCCESS,
  FETCH_RECENT_ACTIVITIES_FAILURE,
  FETCH_RECENT_ACTIVITIES_REQUEST,
  FETCH_RECENT_ACTIVITIES_SUCCESS,
} from './types';

const INITIAL_STATE = {
  activities: {},
  activityLoading: false,
  activityError: null,
  auditTrailData: [],
  auditTrailLoading: false,
  auditTrailError: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_RECENT_ACTIVITIES_REQUEST:
      return {
        ...state,
        activityLoading: true,
      };
    case FETCH_RECENT_ACTIVITIES_SUCCESS:
      return {
        ...state,
        activityLoading: false,
        activities: action.payload,
      };
    case FETCH_RECENT_ACTIVITIES_FAILURE:
      return {
        ...state,
        activityLoading: false,
        activities: {},
        activityError: action.payload,
      };
    case FETCH_AUDIT_TRAIL_REQUEST:
      return {
        ...state,
        auditTrailLoading: true,
      };
    case FETCH_AUDIT_TRAIL_SUCCESS:
      return {
        ...state,
        auditTrailLoading: false,
        auditTrailData: action.payload,
      };
    case FETCH_AUDIT_TRAIL_FAILURE:
      return {
        ...state,
        auditTrailLoading: false,
        auditTrailData: {},
        auditTrailError: action.payload,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
